export default {"src":"/_next/static/media/footer_call.e7adaa24.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};